// A subscription bought outright, or a plan that converts into its
// planSubscription after the first shipment. A plan with no planSubscription
// is a one-time purchase and never triggers the disclosure (mirrors
// Product#enrolls_subscription? on the server).
export function isDisclosedProduct(product) {
  const type = product?.productType?.toLowerCase();
  if (type === 'subscription') {
    return true;
  }
  return type === 'plan' && Boolean(product?.planSubscription?.id);
}

// Cart items that each need their own acknowledgment: a plan (which turns
// into its planSubscription later) or a subscription bought directly. One
// item per patient, so a multi-patient cart yields several.
export function disclosedCartItems(cart) {
  return (cart?.cartItemsAttributes || []).filter((cartItem) =>
    isDisclosedProduct(cartItem?.product),
  );
}

export function disclosedCartProducts(cart) {
  return disclosedCartItems(cart).map((cartItem) => cartItem.product);
}

export function requiresSubscriptionDisclosure(cart) {
  return disclosedCartItems(cart).length > 0;
}

export default requiresSubscriptionDisclosure;
